export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-2560x1600-acab1242f7587b3110190a2f79e85542.jpg";